import {Model} from "@tailflow/laravel-orion/lib/model";

export default class EnquiryMessage extends Model<{}> {
    public $resource(): string {
        return "enquiry_messages";
    }

    public $getKeyName() : string {
        return 'id';
    }
}